import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  switchMap
} from 'rxjs/operators';
import { StatusTrackerFacadeService } from '../../facades/status-tracker/status-tracker-facade.service';
import { CommonRequest } from '../../models/status-tracker/api/api-status-tracker.interfaces';
import { ContentService } from '../../services/status-tracker/content.service';
import { StatusTrackerService } from '../../services/status-tracker/status-tracker.service';
import * as StatusTrackerActions from '../actions/status-tracker.actions';

@Injectable()
export class StatusTrackerEffects {
  loadStatusTrackerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StatusTrackerActions.loadStatusTracker),
      switchMap(() =>
        this.statusTrackerFacade.serviceConfiguration$.pipe(
          distinctUntilChanged(
            (previous, current) =>
              JSON.stringify(previous) === JSON.stringify(current)
          ),
          filter((payload) => !!payload),
          switchMap((payload: CommonRequest) =>
            this.statusTrackerService.getStatusTrackerResponse(payload).pipe(
              filter((content) => !!content),
              switchMap((content) => {
                return of(
                  StatusTrackerActions.loadStatusTrackerSuccess({
                    tracker: {
                      id: 'status-tracker-content',
                      statusTrackerContent: content
                    }
                  })
                );
              })
            )
          ),
          catchError(() =>
            of(
              StatusTrackerActions.loadStatusTrackerFailure({
                error: {
                  id: 'status-tracker-content-error',
                  statusTrackerContentError: 'tracker'
                }
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly statusTrackerService: StatusTrackerService,
    private readonly statusTrackerFacade: StatusTrackerFacadeService,
    private readonly content: ContentService
  ) {}
}
